module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-login-v3 layout-full th"
  }, [_c('div', {
    staticClass: "page vertical-align text-xs-center"
  }, [_c('div', {
    staticClass: "page-content vertical-align-middle"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [((this.step < 2)) ? _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('register.labels.register')))]) : _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('register.action.registerSuccess')))]), _vm._v(" "), _c('div', {
    staticClass: "pearls row"
  }, [_c('div', {
    staticClass: "pearl current col-xs-4",
    class: {
      'done': (this.step === 0)
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "pearl-title"
  }, [_vm._v(_vm._s(_vm.$t('account.labels.account')))])]), _vm._v(" "), _c('div', {
    staticClass: "pearl col-xs-4",
    class: {
      'current': (this.step > 0)
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "pearl-title"
  }, [_vm._v(_vm._s(_vm.$t('team.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "pearl col-xs-4",
    class: {
      'current': (this.step > 1)
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "pearl-title"
  }, [_vm._v(_vm._s(_vm.$t('register.action.finish')))])])]), _vm._v(" "), _c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAlert),
      expression: "showAlert"
    }],
    attrs: {
      "alertClass": "alert-dismissible",
      "type": "danger"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorResponse))])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade-in",
      "mode": "out-in",
      "appear": ""
    }
  }, [(this.step === 0) ? _c('div', {
    key: "user-register",
    staticClass: "user-form"
  }, [_c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('displayname')
    }
  }, [_c('label', {
    attrs: {
      "for": "displayname font-size-24"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.labels.displayName')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.displayname),
      expression: "user.displayname"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "id": "displayname",
      "placeholder": _vm.$t('account.labels.displayName')
    },
    domProps: {
      "value": _vm._s(_vm.user.displayname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.displayname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.labels.email')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": _vm.$t('account.labels.email')
    },
    domProps: {
      "value": _vm._s(_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('password')
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.labels.password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": _vm.$t('account.labels.password')
    },
    domProps: {
      "value": _vm._s(_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-primary btn-lg btn-submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("action.continue")) + " "), _c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  })])], 1) : _vm._e(), _vm._v(" "), (this.step === 1) ? _c('div', {
    key: "team-register",
    staticClass: "default-form"
  }, [_c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('team')
    }
  }, [_c('label', {
    attrs: {
      "for": "team"
    }
  }, [_vm._v(_vm._s(_vm.$t('team.displayName.labels')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.team),
      expression: "user.team"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "id": "team",
      "placeholder": "Team Display name"
    },
    domProps: {
      "value": _vm._s(_vm.user.team)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.team = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('namespace')
    }
  }, [_c('label', {
    attrs: {
      "for": "namespace"
    }
  }, [_vm._v(_vm._s(_vm.$t('team.url.labels')) + " "), _c('span', {
    staticClass: "grey-400 font-size-12"
  }, [_vm._v(_vm._s(_vm.$t('team.url.textGuide')))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s((_vm.baseURL + "/")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.namespace),
      expression: "user.namespace"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "id": "namespace",
      "placeholder": "Team URL"
    },
    domProps: {
      "value": _vm._s(_vm.user.namespace)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.namespace = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('accept')
    }
  }, [_c('div', {
    staticClass: "checkbox-custom checkbox-primary m-b-0 m-t-20 text-xs-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.accept),
      expression: "user.accept"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.accept) ? _vm._i(_vm.user.accept, null) > -1 : (_vm.user.accept)
    },
    on: {
      "click": function($event) {
        var $$a = _vm.user.accept,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.user.accept = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.user.accept = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.user.accept = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "term"
    }
  }, [_vm._v(_vm._s(_vm.$t("register.labels.acceptTerm")) + " "), _c('a', {
    staticClass: "p-0 m-0",
    attrs: {
      "href": "https://www.byteark.com/terms-of-service/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("register.labels.termOfService")))])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-primary btn-lg btn-submit",
    class: {
      'btn-default': _vm.isSubmiting
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmiting
    }
  }, [(_vm.isSubmiting) ? _c('div', {
    staticClass: "loader vertical-align-middle loader-circle loader-form"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t('action.register')) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (this.step === 2) ? _c('div', {
    key: "completed-register",
    staticClass: "default-form"
  }, [_c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('register.success')) + " " + _vm._s(_vm.user.email))])])]) : _vm._e()])], 1), _vm._v(" "), ((this.step < 2)) ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t("account.labels.existingAccount"))), _c('u', [_c('router-link', {
    staticClass: "btn btn-link btn-register",
    attrs: {
      "to": "login"
    }
  }, [_vm._v(_vm._s(_vm.$t("action.login")))])], 1)]) : _vm._e()], 1)]), _vm._v(" "), _vm._m(4)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand"
  }, [_c('img', {
    staticClass: "brand-img",
    attrs: {
      "src": "/static/images/byteark-loading-white.png",
      "alt": "logo account",
      "width": "180"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "brand-text font-size-24 grey-100"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pearl-icon"
  }, [_c('i', {
    staticClass: "icon md-account",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pearl-icon"
  }, [_c('i', {
    staticClass: "icon md-accounts-list",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pearl-icon"
  }, [_c('i', {
    staticClass: "icon md-check",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "page-copyright page-copyright-inverse"
  }, [_c('p', [_vm._v("Service by ByteArk")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-764264cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/Register.vue
// module id = 546
// module chunks = 1